import cn from 'classnames';
import { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import { ICellProps } from '@creditflowresearch/uilib/Table/DataTable';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { StatusIndicator, StatusIndicatorType } from '@creditflowresearch/uilib/StatusIndicator';
import { IRoadshowsTileView } from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsTileView';
import RoadshowLink from '@/creditflowresearch/ui/components/Roadshows/RoadshowLink';
import DealButton from '@/creditflowresearch/ui/components/Roadshows/DealButton';

import styles from './roadshowsTile.module.scss';
import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import spaceStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

const columns: IColumn[] = [
  {
    name: 'status',
    className: alignStyles.alignCenter,
    width: 28,
    cellCallback: () => (
      <Tooltip
        placement="bottom"
        content="Live"
        className={ styles.hideTooltipOnMobile }
      >
        <StatusIndicator status={ StatusIndicatorType.live } />
      </Tooltip>
    ),
  },
  {
    title: 'Name',
    name: 'dealName',
    cellCallback: ({ row: { dealName, email, entryCode } }: ICellProps<IRoadshowsTileView>) => (
      <RoadshowLink title={ dealName } email={ email } entryCode={ entryCode } />
    ),
  },
  {
    name: 'viewRoadshow',
    width: 123,
    className: cn(spaceStyles.pln, spaceStyles.prn),
    cellCallback: ({
      row: {
        entryCode,
        email,
      },
    }: ICellProps<IRoadshowsTileView>) => (
      <RoadshowLink
        title="View Roadshow"
        email={ email }
        entryCode={ entryCode }
        className={ cn(styles.roadshowButton, alignStyles.flexCenter) }
      />
    ),
  },
  {
    name: 'dealCard',
    width: 101,
    cellCallback: ({ row: { dealUrl } }: ICellProps<IRoadshowsTileView>) => (
      <DealButton url={ dealUrl } className={ cn(styles.dealButton, alignStyles.flexCenter) } />
    ),
  },
];

export default columns;
